import {
  ComplianceCalendarFilters,
  ComplianceCalendarViewSettings,
} from '@monorepo/shared/apiClient/complianceCalendar';
import { ComplianceCalendarEventType } from 'mapistry-shared';

export const DEFAULT_COMPLIANCE_CALENDAR_FILTERS: ComplianceCalendarFilters = {
  eventTypes: [
    ComplianceCalendarEventType.LOG,
    ComplianceCalendarEventType.TASK,
    ComplianceCalendarEventType.INSPECTION,
  ],
  userIds: [],
  hideCompleted: false,
};

export const DEFAULT_COMPLIANCE_CALENDAR_VIEW: ComplianceCalendarViewSettings =
  {
    view: 'dayGridMonth',
  };
